<template>
  <EntityEditCard :title="$t('servicesystem.common_objects.supplier.sync_options')" :item="supplier"
    :saveMethod="saveMethod" :readonly="readonly">
    <template v-slot:content="{ item, editMode, handleFocus }">
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <QTextField v-model="item.CentralSystemId"
              :label="$t('servicesystem.common_objects.supplier.central_system_id')" :externaledit="editMode" :disabled="readonly"
              @FocusState="handleFocus">
            </QTextField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <QCheckboxInput v-model="item.SyncActivated" :label="$t('servicesystem.common_objects.supplier.sync_active')"
              :externaledit="editMode" :disabled="readonly" @FocusState="handleFocus">
            </QCheckboxInput>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <QCheckboxInput v-model="item.RemoveLocalDocuments"
              :label="$t('servicesystem.common_objects.supplier.remove_local_documents')" :externaledit="editMode"
              :disabled="readonly" @FocusState="handleFocus">
            </QCheckboxInput>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </EntityEditCard>
</template>


<script>
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";

export default {
  name: "SupplierSyncOptions",
  props: {
    supplier: Object,
    saveMethod: Function,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EntityEditCard,
  },
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>